import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => ({
  root: {
    position: "relative",
    ["&::after"]: {
      content: "' '",
      left: "0",
      right: "0",
      bottom: "0",
      height: "1px",
      position: "absolute",
      backgroundColor: theme.busbud.colors.border.primary.opaque,
      zIndex: 1
    }
  },
  content: {
    ["&::after"]: {
      paddingBottom: theme.busbud.spacing(3)
    }
  },
  actions: {
    borderTop: `1px solid ${theme.busbud.colors.border.primary.opaque}`,
    padding: theme.busbud.spacing(2)
  }
}));
